import "./app";

// Só importar performance e analytics em produção
if (import.meta.env.PROD) {
  import("./performance");
  import("./analytics");
}

export { default as functions } from "./functions";
export { default as auth } from "./auth";
export { default as firestore } from "./firestore";
